// Seconds to wait after a 429 from the auth endpoints: body retry_after, else the Retry-After header.
// Clamped to 1 s .. 24 h (the longest server window); 60 s when neither is usable.
export const MAX_RETRY_AFTER_SECONDS = 24 * 3600;
export const DEFAULT_RETRY_AFTER_SECONDS = 60;

const usable = (value) => {
  const n = typeof value === 'string' && value.trim() === '' ? NaN : Number(value);
  return Number.isFinite(n) && n > 0 ? Math.min(Math.ceil(n), MAX_RETRY_AFTER_SECONDS) : null;
};

export const retryAfterSeconds = (error) => {
  const headers = error?.response?.headers;
  const header = headers?.['retry-after'] ?? headers?.['Retry-After'];
  return usable(error?.response?.data?.retry_after) ?? usable(header) ?? DEFAULT_RETRY_AFTER_SECONDS;
};

export const formatCountdown = (seconds) => {
  const s = Math.max(0, Math.floor(Number(seconds) || 0));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};
